var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "hb-copy" },
    [
      _c("hb-icon-button", {
        attrs: {
          icon: _vm.copied ? "CheckIcon" : "CopyIcon",
          tone: _vm.copied ? "success" : "primary",
          label: _vm.$t("influencer_panel.copy"),
        },
        on: { click: _vm.copy },
      }),
      _vm.shareable
        ? _c("hb-icon-button", {
            attrs: {
              icon: "Share2Icon",
              tone: "primary",
              label: _vm.$t("influencer_panel.share"),
            },
            on: { click: _vm.share },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }